import { Suspense, useMemo } from 'react';
import { useBackgroundScrollLock } from 'react-easyrocket';
import { ErrorBoundary } from 'react-error-boundary';
import { MODAL_MAP } from './config';
import { useModalContext } from 'src/hooks/useModalContext';

const Modal = () => {
  const { openedModalName } = useModalContext();
  const InnerContent = useMemo(
    () => (openedModalName ? MODAL_MAP[openedModalName as keyof typeof MODAL_MAP].component : null),
    [openedModalName]
  );
  useBackgroundScrollLock(Boolean(InnerContent), [InnerContent]);

  return (
    <ErrorBoundary
      fallback={null}
      onError={(error) => console.error('[Modal component error]: ', openedModalName, error)}>
      <Suspense fallback={null}>{InnerContent ? <InnerContent /> : null}</Suspense>
    </ErrorBoundary>
  );
};
export default Modal;
